import { drupalComponent } from '@nech/src/helpers/drupal-component';

(function (Drupal, $) {
  drupalComponent('scrollTopButton', {
    selector: '.scroll-to-top-button',

    shared: {},

    attach(context, options) {
      const $el = $(this.selector, context);
      const $footer = $('footer');
      const bannerHeight = $('.nech-banner--content').outerHeight() || 0;
      const headerHeight = $('#navigation').outerHeight() || 0;

      if (!$el.length) return;

      const buttonHeight = $el.outerHeight() || 0;
      const footerHeight = $footer.outerHeight() || 0;

      // Initialement masqué;

      $(window).on('scroll', function () {
        const scrollTop = $(this).scrollTop() ?? 0;
        const windowHeight = $(this).height() ?? 0;
        const documentHeight = $(document).height() ?? 0;

        const scrolledEnough = scrollTop > bannerHeight + headerHeight + 200;
        const overlapsFooter =
          scrollTop + windowHeight >= documentHeight - footerHeight + buttonHeight;

        if (scrolledEnough && !overlapsFooter) {
          $el.removeClass('opacity-0');
        } else {
          $el.addClass('opacity-0');
        }
      });

      // Scroll to top on click
      $el.on('click', function () {
        $('html, body').animate({ scrollTop: 0 + bannerHeight + headerHeight - 100 }, 500);
        return false;
      });
    },
  });
})(Drupal, jQuery);
